import { Order } from 'shell/view-models/order';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { Operation } from 'shell/view-models/operation';
import { FiltersFormMunicipality, MunicipalityClient } from './types';
import { HttpResponseList } from 'shell/models/http-response';
import { FlagMunicipality, Municipality } from 'shell/models/municipality';
import { AxiosResponse } from 'axios';
import { DateTime } from 'luxon';
import { transformMunicipalityFlag } from 'system/geographic/utils/transform-flag-municipality';
import { SelectOperatorChoice } from 'shell/constants/select-choice-operator';
import { translateConsulateValue } from 'shell/utils/translate-consulate-value';

export const transformDataset = (values: FiltersFormMunicipality): string => {
  const { orders, page, rowsPerPage, ...otherValues } = values;

  let name = {},
    nameSearch = {};

  if (otherValues.nameOperation === SelectOperatorChoice.Equal) {
    name = {
      nome: {
        value: otherValues.name || '',
        operation: Operation.EQUALS,
      },
    };
  }

  if (otherValues.nameOperation === SelectOperatorChoice.StartsWith) {
    name = {
      nome: {
        value: otherValues.name || '',
        operation: Operation.LIKE,
      },
    };
  }

  if (otherValues.nameOperation === SelectOperatorChoice.Contains) {
    nameSearch = {
      nomeRicercaLike: {
        value: otherValues.name || '',
        operation: Operation.LIKE,
      },
    };
  }

  const transformedFilters: OperationObject = {
    codice: {
      value: otherValues.code,
      operation: Operation.EQUALS,
    },
    ...name,
    ...nameSearch,
    codIstat: {
      value: otherValues.istatCode,
      operation: Operation.EQUALS,
    },
    provincia: {
      value: otherValues.provinceCode,
      operation: Operation.EQUALS,
    },
    codiceFiscale: {
      value: otherValues.fiscalCode,
      operation: Operation.EQUALS,
    },
  };

  const ordersToTransform = orders || {};

  const ordersMapped: Order = {
    codice: ordersToTransform.code,
    nome: ordersToTransform.name,
    provincia: ordersToTransform.location,
    consolato: ordersToTransform.consulate,
    dataIstituzione: ordersToTransform.institutionDate,
    dataCessazione: ordersToTransform.endDate,
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
    page,
    rowsPerPage,
  })}`;
};

export const transformResponseMunicipalities = (
  response: AxiosResponse<HttpResponseList<Municipality>>
): Array<MunicipalityClient> => {
  return response.data.payload.list.map((municipality) => {
    const institutionDate = municipality.dataIstituz
      ? DateTime.fromISO(municipality.dataIstituz).toFormat('dd/MM/yyyy')
      : '';

    let state = transformMunicipalityFlag(
      (municipality.flag as FlagMunicipality) || FlagMunicipality.Active
    )?.replace('Comune ', '');
    const firstLetter = state.charAt(0).toUpperCase();

    state = firstLetter.toUpperCase() + state.substring(1, state.length);

    const endDate =
      municipality.comuneCessato && municipality.comuneCessato[0]?.dataCessazione
        ? DateTime.fromISO(municipality.comuneCessato[0]?.dataCessazione).toFormat('dd/MM/yyyy')
        : '';

    let location = '';

    /**
     * If exist the object statoEstero then the location field is the name of this field
     */
    if (municipality.statoEsteroVO) {
      location = municipality.statoEsteroVO.nome;
    }

    /**
     * If exist the object provincia then the location field is the name of this field
     */
    if (municipality.provinciaVO || municipality.provincia) {
      location = municipality.provinciaVO?.nome || municipality.provincia || '';
    }

    const cell: MunicipalityClient = {
      code: municipality.key?.codice || '',
      consulate: translateConsulateValue(municipality),
      state,
      endDate,
      totalCount: response.data.payload.pageInfo?.totalCount,
      istatCode: municipality.codIstat || '',
      institutionDate,
      location,
      name: municipality.nome || '',
      isEnded: municipality.flag === FlagMunicipality.Ended,
      isVoid: municipality.flag === FlagMunicipality.Void,
      isForeign:
        !!municipality.statoEsteroVO ||
        municipality.provincia?.trim().length === 3 ||
        municipality.provincia?.length === 1,
    };

    return {
      ...cell,
    };
  });
};
